
/* eslint-disable global-require, import/no-dynamic-require */
import Vue from 'vue';
import VueI18n from 'vue-i18n';

import getUser from '~~/common/js/universal/getters/user';
import { DEFAULT_LOCALE, LOCALES } from '~~/common/js/constants/i18n';

Vue.use(VueI18n);

const getLocale = ({ req, store }) => {
  // server-side, we have the request object, so we can get the locale from either
  // the req directly (currently only indexpage sets it) or the ecosia-user instance
  if (process.server) {
    return req.locale || getUser(req).get('language');
  }
  // client-side, the locale should already be in store
  return store.state.global.locale;
};

/**
 * This module provides the VueI18n plugin set up with
 * both common and project-specific translations
 */
export default async (context) => {
  const { app } = context;
  const locale = getLocale(context) || DEFAULT_LOCALE;
  const locales = LOCALES.filter((lcl) => lcl === locale || lcl === DEFAULT_LOCALE);
  const messagePromises = locales.map(async (lcl) => {
    const common = await import(/* webpackChunkName: "common-locale-[request]" */ `~~/common/locales/${lcl}.json`);
    const local = await import(/* webpackChunkName: "locale-[request]" */ `~/locales/${lcl}.json`);
    return [lcl, { ...common, ...local }];
  });
  const messageEntries = await Promise.all(messagePromises);
  const messages = Object.fromEntries(messageEntries);
  app.i18n = new VueI18n({
    locale,
    fallbackLocale: DEFAULT_LOCALE,
    messages,
  });
};
